import { Fragment, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ContactForm from "../../components/ContactFrom/ContactForm";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import StarLoader from "../loader/StarLoader";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const EventSinglePage = () => {
  const { id } = useParams();
  const [eventDetails, setEventDetails] = useState(null);
  const [relatedEvents, setRelatedEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    async function fetchEvent() {
      try {
        // Fetch single event
        const response = await fetch(`${apiUrl}/api/event_list/${id}`);
        const data = await response.json();
        if (!isMounted) return;

        setEventDetails(data);
        setMainImage(data.banner);

        // Fetch related events
        const relatedResponse = await fetch(`${apiUrl}/api/event_list`);
        const relatedData = await relatedResponse.json();
        if (!isMounted) return;

        setRelatedEvents(
          relatedData.filter((ev) => ev.id !== data.id).slice(0, 3)
        );
      } catch (error) {
        console.error("Error fetching event:", error);
      } finally {
        if (isMounted) setLoading(false); // ✅ no timer, instant loading stop
      }
    }

    fetchEvent();

    return () => {
      isMounted = false; // ✅ cleanup to prevent setState after unmount
    };
  }, [id, apiUrl]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  if (!eventDetails) {
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>Event not found</p>
    );
  }

  const imagesArray = eventDetails.images
    ? JSON.parse(eventDetails.images)
    : [];

  const buttonContainerStyle = {
    textAlign: "center",
  };

  const buttonStyle = {
    background: "linear-gradient(90deg, #001F5C, #007BFF)",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s ease",
    boxShadow: "0 0 8px rgba(0, 31, 92, 0.5)", // glowing orange shadow for button
  };

  return (
    <Fragment>
      <section
        className="wpo-service-single-area section-padding"
        style={{
          backgroundColor: "#E6F7FF",
          paddingTop: "40px", // reduce vertical padding
          paddingBottom: "40px", // reduce vertical padding
        }}
      >
        <div className="container">
          <div
            className="row align-items-start"
            style={{
              padding: "40px 20px",
              borderTop: "1px solid #eee",
              borderBottom: "1px solid #eee",
            }}
          >
            {/* Event Images */}
            <div
              className="col col-lg-5 col-12"
              style={{ marginBottom: "20px" }}
            >
              <div
                className="shop-single-slider"
                style={{ textAlign: "center" }}
              >
                <div style={{ marginBottom: "15px" }}>
                  <Zoom>
                    <img
                      src={`${apiUrl}/storage/${mainImage}`}
                      alt={eventDetails.eventName}
                      style={{
                        width: "100%", // Fill full width of parent container
                        maxWidth: "100%", // Prevent overflow
                        height: "350px", // Increase height for larger display
                        objectFit: "cover", // Makes it cover fully, cropping if needed
                        objectPosition: "center", // Center the focus of the image
                        borderRadius: "20px",
                        border: "1px solid lightgray",
                        marginBottom: "15px",
                        backgroundColor: "#f5f5f5", // Optional: fills space for small images
                        boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                      }}
                    />
                  </Zoom>
                </div>

                {/* Thumbnails */}
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={`${apiUrl}/storage/${eventDetails.banner}`}
                    alt="banner-thumb"
                    onClick={() => setMainImage(eventDetails.banner)}
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "cover",
                      borderRadius: "5px",
                      border:
                        mainImage === eventDetails.banner
                          ? "2px solid #000"
                          : "1px solid #ddd",
                      cursor: "pointer",
                      boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                    }}
                  />
                  {imagesArray.map((img, index) => (
                    <img
                      key={index}
                      src={`${apiUrl}/storage/${img}`}
                      alt={`event-${index}`}
                      onClick={() => setMainImage(img)}
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "cover",
                        borderRadius: "5px",
                        border:
                          mainImage === img
                            ? "2px solid #000"
                            : "1px solid #ddd",
                        cursor: "pointer",
                        boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Event Details */}
            <div className="col col-lg-7 col-12">
              <div className="service-details" style={{ padding: "0 20px" }}>
                <h2
                  style={{
                    fontSize: "28px",
                    marginBottom: "15px",
                    color: "#222",
                  }}
                >
                  {eventDetails.eventName}
                </h2>

                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.6",
                    marginBottom: "15px",
                    color: "#555",
                  }}
                  dangerouslySetInnerHTML={{ __html: eventDetails.description }}
                />

                <ul
                  style={{
                    paddingLeft: "20px",
                    marginBottom: "20px",
                    color: "#444",
                  }}
                >
                  <li
                    dangerouslySetInnerHTML={{ __html: eventDetails.details }}
                  />
                </ul>
              </div>
            </div>
          </div>

          {/* Related Events */}
          {relatedEvents.length > 0 && (
            <div
              className="wpo-service-single-item"
              style={{ marginTop: "50px" }}
            >
              {/* 🔸 Section Title */}
              <div
                className="wpo-service-single-title"
                style={{
                  marginBottom: "30px",
                  padding: "15px 40px",
                  borderRadius: "10px",
                  color: "#fff",
                  boxShadow: "0 0 40px 5px rgba(0, 0, 139, 0.25)", // ✅ dark blue box shadow only
                  background: "#fff",
                }}
              >
                <h3 style={{ margin: 0 }}>Related Events</h3>
              </div>

              {/* 🔸 Grid Layout (like Related Services) */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                  gap: "20px",
                }}
              >
                {relatedEvents.slice(0, 3).map((event) => (
                  <Link
                    to={`/event-single/${event.id}`}
                    key={event.id}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        borderRadius: "10px",
                        boxShadow: "0 4px 15px rgba(0,0,139,0.15)",
                        overflow: "hidden",
                        height: "420px",
                        display: "flex",
                        flexDirection: "column",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,139,0.35)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,139,0.15)";
                      }}
                    >
                      {/* 🖼 Image (full-width cover style) */}
                      <div style={{ height: "200px", overflow: "hidden" }}>
                        <img
                          src={`${apiUrl}/storage/${event.banner}`}
                          alt={event.eventName}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            transition: "transform 0.4s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </div>

                      {/* 🧾 Details */}
                      <div
                        style={{
                          padding: "15px",
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "8px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {event.eventName}
                        </h3>

                        <p
                          style={{
                            flexGrow: 1,
                            color: "#555",
                            fontSize: "14px",
                            lineHeight: 1.4,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            marginBottom: "10px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: event.description,
                          }}
                        />
                        <div style={buttonContainerStyle}>
                          <Link
                            onClick={ClickHandler}
                            to={`/event-single/${event.id}`}
                          >
                            <button
                              style={buttonStyle}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background =
                                  "linear-gradient(90deg, #002B80, #339CFF)";
                                e.currentTarget.style.boxShadow =
                                  "0 0 15px rgba(0, 123, 255, 0.6)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background =
                                  "linear-gradient(90deg, #001F5C, #007BFF)";
                                e.currentTarget.style.boxShadow =
                                  "0 0 8px rgba(0, 31, 92, 0.5)";
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-html="true"
                              title="Add to Cart"
                            >
                              View Details
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}

          {/* Contact Form */}
          <div
            className="wpo-service-single-item"
            style={{ marginTop: "60px", textAlign: "center" }}
          >
            <div className="wpo-service-contact-area">
              <div className="wpo-contact-title">
                <h2
                  style={{
                    background: "linear-gradient(90deg, darkblue, #1E90FF)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: "700",
                    fontSize: "2rem",
                  }}
                >
                  Interested in Participating or Partnering?
                </h2>
                <p style={{ color: "#4b5563", fontSize: "1.05rem" }}>
                  Get in touch with Star Family Industry PLC to learn more about
                  our upcoming trade and business events.
                </p>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default EventSinglePage;
